export const themeF = {
  name: "深海翡翠",
  colors: {
    bg: "#0A1210",
    bgSecondary: "#121E1A",
    text: "#E8F4F0",
    textSecondary: "#A0C4B8",
    textMuted: "#8CA096",
    accent: "#4ABFA0",
    accentText: "#0A1210",
    accentAlt: "#3CA888",
    accentWarm: "#78D4B4",
    accentOrange: "#6CC4A0",
    available: "#5CC488",
    availableText: "#0A1210",
    claimed: "#2A3E36",
    cardBg: "#0E1A16",
    cardBorder: "#223830",
    overlay: "rgba(10,18,16,0.8)",
    heroBg: "#0A1210",
    heroText: "#E8F4F0",
  },
  fonts: {
    heading: "var(--font-dm-serif), 'Noto Serif TC', serif",
    body: "var(--font-noto-sans), sans-serif",
    accent: "var(--font-dm-serif), serif",
  },
  radius: { sm: "6px", md: "10px", lg: "16px", full: "9999px" },
  spacing: { cardGap: "20px", sectionGap: "52px", pagePadding: "20px" },
  effects: {
    cardShadow: "0 2px 16px rgba(74,191,160,0.06)",
    cardHoverShadow: "0 4px 24px rgba(74,191,160,0.12)",
    bgTexture: true,
    textureOpacity: 0.02,
  },
};
